import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getAccountDetails } from "../../store/actions/userOnboarding";
import { CircularProgress } from "@material-ui/core";
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Paper } from "@material-ui/core";
import PropTypes from "prop-types";

const Item = ({ label, value }) => (
  <div className="mb-3">
    <strong>{label}:</strong> <span className="text-muted">{value}</span>
  </div>
);

Item.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string
};
export default function AccountDetails(props) {
  const {isViewUserRequest, data, activeStep, handleBack, handleNext, isApprovedSeller} = props;
  const dispatch = useDispatch();
  const {accountDetails, accountDetailsStatus} = useSelector((state) => state.userOnboarding);
  const [userData, setUserData] = React.useState({});
  const [loader, setLoader] = React.useState(false);

  useEffect(() => {
    if (accountDetailsStatus === "success" || accountDetailsStatus === "failed") { 
      setLoader(false);
    } else if (accountDetailsStatus === "pending") {
      setLoader(true);
    }
  }, [accountDetailsStatus]);

  useEffect(() => {
    setUserData(accountDetails || {}); // Update userData when accountDetails changes
  }, [accountDetails]);

  useEffect(() => {
    dispatch(getAccountDetails(isViewUserRequest, data, isApprovedSeller));
  }, [dispatch, isViewUserRequest, isApprovedSeller, data?.Id, data?.onboardingId]);

  const getButtonText = () => {
    if (activeStep === 0) {
      return "Next";
    }
    if (activeStep === 4) {
      return "Save";
    }
    return "Save & Next";
  };

  return (
    <Container fluid>
      <Paper className='onboardingFormWrapping fw-3' elevation={2} square>
        {loader && (<div className="full-screen-spinner-overlay"><CircularProgress disableShrink /></div>)}
        <h6 className="fw-bold mb-3 font-20">Account Details</h6>   
        <hr className="my-4" />
        <Row className="my-4">
            <Col md={6} lg={6}>
                <Item label="First Name" value={userData.firstName} />
                <Item label="User Name" value={userData.userName} />
                <Item label="Email" value={userData.email} />
            </Col>

            <Col md={6} lg={6}>
                <Item label="Last Name" value={userData.lastName} />
                <Item label="Company" value={userData.companyName} />
                <Item label="Sign-Up Reason" value={userData.signUpReason} />
            </Col>
        </Row>

        <h6 className="fw-bold mb-3 font-20">Address Details</h6>
        <hr className="my-4" />

        <Row>
            <Col md={6} lg={6}>
                <Item label="Country" value={userData.country} />
                <Item label="State" value={userData.state} />
                <Item label="Phone Number" value={userData.phoneNumber} />
                <Item label="Address Line 1" value={userData.addressLine1} />
            </Col>

            <Col md={6} lg={6}>
            <Item label="Zip Code" value={userData.zipCode} />
            <Item label="City" value={userData.city} />
            <Item label="Secondary Phone" value={userData.secondaryPhone} />
            <Item label="Address Line 2" value={userData.addressLine2} />
            </Col>
        </Row>
      </Paper>
      <div className='flexPayment mt-2'>
        {!isViewUserRequest ? <Typography component="em">* Please complete the form to finalize your onboarding process</Typography> : <Typography component="em"></Typography>}
        <div className="mt-3 alignItemsCenter">
          <Button disabled={activeStep === 0} onClick={handleBack} disableElevation>
            Back
          </Button>
          <Button
            disableElevation
            variant="contained"
            color="primary"
            onClick={handleNext}
            className='cus-seconday-bg-btn btn ml-2'
          >
            {getButtonText()}
          </Button>
        </div>
      </div>
    </Container>
  );
};


AccountDetails.propTypes = {
  isViewUserRequest: PropTypes.bool,
  data: PropTypes.object,
  isApprovedSeller: PropTypes.bool,
  activeStep: PropTypes.number,
  handleBack: PropTypes.func,
  handleNext: PropTypes.func,
}
